export default __webpack_public_path__ + "assets/apple-icon-60x60.480699de476982cbc497ebc8dd5388cc.png";